import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
    marginBottom: theme.spacing(16),
  },
  selectSubscription: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    color: theme.palette.select.light,
    cursor: 'pointer',
    fontWeight: 500,
  },
  renewOfferFooterWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    alignItems: 'center',
  },
  btnWrapper: {
    display: 'flex',
    gap: theme.spacing(3),
  },
}))
